
const INITIAL_STATE = {}

const ControlConfig = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'CONFIG_CONTROL_SET':
            return {...state, ...action.payload}
        default:
            return state;
    }
}

export default ControlConfig